import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, Inject, ViewChild, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-doocti-call',
  templateUrl: './doocti-call.component.html',
  styleUrls: ['./doocti-call.component.scss']
})
export class DooctiCallComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  data: any;
  dialerShow: boolean;
  LeadCallOject: any;
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data, private router: Router

  ) {
    console.log(data);  
    this.data = data
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }
  
  iframeInitialized: boolean = false;

  initializeIframe(): void {
  }
  ngOnInit(): void {
    if (!this.iframeInitialized) {
      this.initializeIframe();
      this.iframeInitialized = true;
    }
    console.log(this.data);
    this.dialerShow = true;
  }

  closeModal(){
    this.dialog.closeAll();
  }

  
  object={
    "entity_type": "Lead",
    "entity_id": "1",
    "entity_name": "yesh",
    "entity_number": "893972994",
    "tenant_id": " Account Id",
    "user_email": "calsoft_agent01@doocti.com",
    "user_id": "1",
    "user_number": "362"
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(){

    const iframeWindow = this.myFrame.nativeElement.contentWindow;
    
    window.addEventListener('message', this.receiveMessage.bind(this));
    

        console.log(this.data);
        
        const postData = {
          "entity_type": "Lead",
          "entity_id": this.data.data.entityId,
          "entity_name": this.data.data.name,
          "entity_number": this.data.data.phoneNumber.toString(),
          "tenant_id": "Account Id",
          "user_email": this.data.data.ownerEmail,
          "user_id": this.data.data.ownerId,
          "user_number": "362"
        };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');

  }


  isMinimized = false;

  minimizeToggle() {
    this.isMinimized = !this.isMinimized;
  }

    // Function to handle messages received from iframe
    receiveMessage(event: MessageEvent) {
      // Ensure message is from expected origin
      if (event.origin !== 'https://crm-app.doocti.com') {
        return;
      }
      
      console.log('Received message from iframe:', event.data);
    }


    openCallDialog(){
      document.getElementById("mydailer").style.display = "block";
        this.dialerShow = false;
    }
  
    dialCloseDialog(){
      document.getElementById("mydailer").style.display = "none";
      this.dialerShow = false;
    }
  


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
